import { useTranslation } from "react-i18next";

const ErrorFallback = ({ error, resetErrorBoundary }) => {

  const { t } = useTranslation();
  const message = t('errorScreen.message');
  const retryText = t('errorScreen.tryAgain');

  return (
    <div role="alert">
      <p>{message}:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>{retryText}</button>
    </div>
  )
};

export default ErrorFallback;